import React from "react";
import PropTypes from "prop-types";

import style from "./style.module.scss";

export function Title(props) {
  const className = `${style.title} ${props.className}`;
  return <h6 className={className}>{props.message}</h6>;
}

Title.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * title message in modal
   */
  message: PropTypes.string,
};

Title.defaultProps = {
  className: "",
};
